// Google Analytics 4 helpers. Safe no-ops when the measurement ID is unset
// (e.g. local/preview) or gtag hasn't loaded yet, so call sites never need guards.

// Only treat a real GA4 Measurement ID (G-XXXXXXXXXX) as configured  - ignore
// blanks and placeholder values like "your-ga-id" so we never load a bogus tag.
const RAW_GA_ID = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID;
export const GA_ID = RAW_GA_ID && /^G-[A-Z0-9]+$/i.test(RAW_GA_ID) ? RAW_GA_ID : undefined;

type GtagParams = Record<string, unknown>;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

const ready = (): boolean =>
  !!GA_ID &&
  typeof globalThis.window !== 'undefined' &&
  typeof globalThis.window.gtag === 'function';

/** Send a SPA page_view (route changes don't auto-fire in the App Router). */
export const pageview = (url: string): void => {
  if (!ready()) return;
  globalThis.window.gtag!('event', 'page_view', {
    page_path: url,
    page_location: globalThis.window.location.href,
    page_title: document.title,
  });
};

/** Send a custom GA4 event, e.g. track('generate_lead', { form: 'wholesale' }). */
export const track = (event: string, params: GtagParams = {}): void => {
  if (!ready()) return;
  globalThis.window.gtag!('event', event, params);
};
